// ;(());
export default function webkcrypt_globals() {
  window.cadesplugin_skip_extension_install = true;
  window.cadesplugin_load_timeout = 500;
}
